<template>
	<transition-group
		v-bind:css="false"
		v-on:enter="enter"
		v-on:leave="leave">
		<slot></slot>
	</transition-group>
</template>

<script>
	import gasp from 'gsap';
	export default {
		props: {
			duration: {
				type: Number,
				default: .5
			}
		},
		methods: {
			enter(el, done) {
				gasp.from(el, {duration: this.duration, height: 0, opacity: 0, y: -20, paddingTop: 0, paddingBottom: 0, margin: 0, clearProps:'all', onComplete: done})
			},
			leave(el, done) {
				gasp.to(el, {duration: this.duration, height: 0, opacity: 0, y: -20, paddingTop: 0, paddingBottom: 0, margin: 0, clearProps:'all', onComplete: done})
			}
		},
	}
</script>